<template>
  <TableCell :tag="tag" :popoverDisabled="true" style="font-family: Reddit Mono;">
    {{ formattedDuration() }}
  </TableCell>
</template>

<script>
import TableCell from "./TableCell.vue";
import { modeTimesBySessionId } from "./OperationModeStatus.vue";

export default {
  components: { TableCell },
  props: [
    "tag",
    "modeIndex",
    "whichTime"
  ],
  methods: {
    formattedDuration() {
      let bin = this.tag;
      let binNumber = bin.$key();
      let session = this.tag.$session;
      let sessionModeTimes = modeTimesBySessionId.value[session.sessionId];
      if (sessionModeTimes == null) 
        return;
      
      let isColumnTotal = (this.whichTime == "modesTotal" || this.whichTime == "fansTotal");
      let totalSeconds = (isColumnTotal 
        ? this.getColumnTotalSeconds(sessionModeTimes, binNumber)
        : this.getCellTotalSeconds(sessionModeTimes, binNumber)
      );
      let hours = parseInt(totalSeconds / 3600);
      let hoursString = hours.toString().padStart(2, " ");
      let remainingSeconds = totalSeconds - (hours * 3600);
      let minutes = parseInt(remainingSeconds / 60);
      let minutesString = minutes.toString().padStart(2, "0");
      remainingSeconds = remainingSeconds - (minutes * 60);
      let secondsString = remainingSeconds.toString().padStart(2, "0");
      return `${hoursString}:${minutesString}:${secondsString}`;
    },
    getColumnTotalSeconds(sessionModeTimes, binNumber) {
      let columnTotal = 0;
      let whichTimeTotal = (() => {
        if (this.whichTime == "modesTotal") return "modeTime";
        if (this.whichTime == "fansTotal") return "fanTime";
      })();
      for (let i = 0; i < sessionModeTimes[binNumber].length; i++) {
        columnTotal += sessionModeTimes[binNumber][i][whichTimeTotal];
      }
      return columnTotal;
    },
    getCellTotalSeconds(sessionModeTimes, binNumber) {
      return sessionModeTimes[binNumber][this.modeIndex][this.whichTime];
    }
  }
}
</script>